// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z3WCG","icon":"styles_icon__1HZrb"};